import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function animation() {
  // フッター TOPスクロールボタン
  const scrollTopWrap = document.querySelector(".l-scroll-top");
  const scrollTopBtn = document.getElementById("js-scrollTop");
  const scrollTopShowOffset = 500;

  if (scrollTopWrap && scrollTopBtn) {
    gsap.set(scrollTopWrap, { autoAlpha: 0 });

    let isScrollTopVisible = false;
    const toggleScrollTop = () => {
      const shouldShow = window.scrollY > scrollTopShowOffset;

      if (shouldShow === isScrollTopVisible) return;

      isScrollTopVisible = shouldShow;
      gsap.to(scrollTopWrap, {
        autoAlpha: shouldShow ? 1 : 0,
        duration: 0.4,
        ease: "power2.out",
      });
    };

    window.addEventListener("scroll", toggleScrollTop, { passive: true });
    toggleScrollTop();

    scrollTopBtn.addEventListener("click", (event) => {
      event.preventDefault();
      gsap.to(window, {
        duration: 1,
        scrollTo: 0,
        ease: "power2.out",
      });
    });
  }

  // フェードインアニメーション
  const fadeInElements = document.querySelectorAll(".js-fade-in");
  fadeInElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power4.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 90%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  const fadeInLeftElements = document.querySelectorAll(".js-fade-in-left");
  fadeInLeftElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        x: -30,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power1.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 80%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  const fadeInRightElements = document.querySelectorAll(".js-fade-in-right");
  fadeInRightElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        x: 30,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power1.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 70%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  // フェードイン（遅延付き）アニメーション
  const fadeInDelayElements = document.querySelectorAll(".js-fade-in-delay");
  fadeInDelayElements.forEach((element, index) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: index * 0.3, // インデックスに応じてディレイ
        ease: "power1.out",
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          // markers: true,
        },
      }
    );
  });
  
}
